var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVotaRosso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.17,
    height: 86.17,
    viewBox: "0 0 86.17 86.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_10123",
    "data-name": "Raggruppa 10123",
    transform: "translate(-18 -254.017)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_1812",
    "data-name": "Ellisse 1812",
    cx: 43.085,
    cy: 43.085,
    r: 43.085,
    transform: "translate(18 254.017)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_10110",
    "data-name": "Raggruppa 10110",
    transform: "translate(0.534 15.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_10109",
    "data-name": "Raggruppa 10109"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_1825",
    "data-name": "Ellisse 1825",
    cx: 7.153,
    cy: 8.314,
    rx: 7.153,
    ry: 8.314,
    transform: "translate(24.327 274.446)",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_1826",
    "data-name": "Ellisse 1826",
    cx: 7.153,
    cy: 8.314,
    rx: 7.153,
    ry: 8.314,
    transform: "translate(81.772 274.446)",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_1827",
    "data-name": "Ellisse 1827",
    cx: 28.374,
    cy: 29.584,
    rx: 28.374,
    ry: 29.584,
    transform: "translate(32.177 251.783)",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32552",
    "data-name": "Tracciato 32552",
    d: "M69.889,301.356a9.283,9.283,0,0,0-9.338-6.807,9.5,9.5,0,0,0-9.464,6.807",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("line", {
    id: "Linea_984",
    "data-name": "Linea 984",
    x2: 3.942,
    y2: 3.942,
    transform: "translate(45.23 281.791)",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_985",
    "data-name": "Linea 985",
    x1: 3.942,
    y2: 3.942,
    transform: "translate(45.23 281.791)",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_986",
    "data-name": "Linea 986",
    x2: 3.942,
    y2: 3.942,
    transform: "translate(71.961 281.791)",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_987",
    "data-name": "Linea 987",
    x1: 3.942,
    y2: 3.942,
    transform: "translate(71.961 281.791)",
    fill: "#fff",
    stroke: "#2a3a90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVotaRosso);
export default __webpack_public_path__ + "static/media/vota-rosso.b04f7c5c8a47db0947116e4c37c1a3e9.svg";
export { ForwardRef as ReactComponent };